(() => {
  const init = (root) => {
    if (!root || root.dataset.shfReady) return;
    root.dataset.shfReady = 'true';
    const desktop = matchMedia('(min-width:750px)');
    const groups = root.querySelectorAll('[data-shf-group]');
    const sync = () => groups.forEach(group => {
      group.open = desktop.matches;
      group.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
    });
    sync();
    desktop.addEventListener('change', sync);

    const cookie = root.querySelector('[data-shf-cookie]');
    if (!cookie) return;
    const banner = () => window.privacyBanner || window.Shopify?.privacyBanner;
    const enableCookies = () => {
      if (typeof banner()?.showPreferences === 'function') cookie.hidden = false;
    };
    enableCookies();
    window.addEventListener('load', enableCookies, {once:true});
    let attempts = 0;
    const timer = setInterval(() => {
      enableCookies();
      if (!cookie.hidden || ++attempts >= 20) clearInterval(timer);
    }, 500);
    cookie.addEventListener('click', () => {
      if (typeof banner()?.showPreferences === 'function') banner().showPreferences();
    });
  };
  document.querySelectorAll('[data-shf]').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-shf]')));
})();
